import { Text } from "@chakra-ui/react";

export const SalesCannotCloseSaleFromBeninPharmacyWithoutMCFTokenError = () => {
  return <Text>Token e-MECeF non défini ou incorrect</Text>;
};
